import * as types from "./types";
import { createAd, fetchAdByTenant, deleteAd, updateAd, switchBannerStatus, fetchPlacementList, adDetails, fetchEntitiesList } from "../../services/advertisement";

export default {
    async fetchAdListforTenant({ commit }, payload) {
        try {
            const data = await fetchAdByTenant(payload)
            commit(types.SET_ADLIST, data.response);
            return data.response
        }
        catch (error) {
            throw error
        }
    },
    async getPlacementList({ commit }, payload) {
        try {
            const data = await fetchPlacementList(payload)
            commit(types.SET_PLACEMENTLIST, data.response);
            return data.response
        }
        catch (error) {
            throw error
        }
    },

    async createAd({ commit }, payload) {
        try {
            const data = await createAd(payload);
            return data;
        } catch (error) {
            throw error
        }

    },

    async updateAdvertisement({ commit }, payload) {
        try {
            const data = await updateAd(payload);
            return data;
        } catch (error) {
            throw error
        }

    }
    ,
    async deleteAd({ commit }, payload) {
        try {
            const data = await deleteAd(payload);
            return data;
        } catch (error) {
            throw error
        }
    },
    async toSwitchBannerStatus({ commit }, payload) {
        try {
            const data = await switchBannerStatus(payload);
            return data;
        } catch (error) {
            throw error
        }
    },
    async setAdobject({ commit }, payload) {
        try {
            commit(types.SET_ADOBJECT, payload);
            return payload;
        } catch (error) {
            throw error
        }
    },

    async fetchAdDetails({ commit }, id) {
        try {
            const data = await adDetails(id);
            commit(types.SET_ADDETAILS, data.response)
            return data.response;
        } catch (error) {
            throw error
        }
    },

    async fetchEntities({ commit }, payload) {
    try {
      const data = await fetchEntitiesList(payload);
      commit(types.SET_ENTITIES, data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
};
